import { AnchorHTMLAttributes, createElement } from 'react';
import { isExternalUrl } from '../../utils/urls';

type AnchorProps = AnchorHTMLAttributes<HTMLAnchorElement | HTMLDivElement> & {
  isInline?: boolean;
  rel?: string;
};

export default function Anchor({ children, isInline, rel, ...rest }: AnchorProps) {
  // Normalize empty string href to undefined to avoid React warnings
  const normalizedHref = rest.href === '' ? undefined : rest.href;
  const { href: _href, ...restWithoutHref } = rest;
  const props = getProps({
    ...restWithoutHref,
    ...(normalizedHref ? { href: normalizedHref } : {}),
    ...(rel ? { rel } : {}),
  });
  const type = normalizedHref ? 'a' : isInline ? 'span' : 'div';

  return createElement(type, props, children);
}

function getProps(props: AnchorProps) {
  const { href, rel } = props;

  if (href && isExternalUrl(href)) {
    return {
      target: '_blank',
      rel: rel ?? 'noopener noreferrer nofollow',
      ...props,
    };
  }

  return props;
}
